import { PhoneCall } from 'legacy/lut/components/shared/PhoneCall'
import { FC, MouseEventHandler, useCallback } from 'react'

import { IClickablePhoneWrapperProps } from './models/iClickablePhoneWrapperProps'

export const ClickablePhoneWrapper: FC<IClickablePhoneWrapperProps> = ({
  phoneNumber,
  partnerId,
  guid,
  children,
  onCall,
  isDisabled,
}) => {
  const handleClick = useCallback<MouseEventHandler<HTMLDivElement>>(
    (e) => {
      if (!isDisabled) {
        e.stopPropagation()
        onCall && onCall(phoneNumber)
      }
    },
    [onCall, phoneNumber, isDisabled]
  )

  if (!phoneNumber) {
    return <div>-</div>
  }

  return (
    <div onClick={handleClick}>
      <PhoneCall
        partnerId={partnerId}
        value={phoneNumber}
        guid={guid}
        isColor
        isDisabled={isDisabled}
      >
        {children}
      </PhoneCall>
    </div>
  )
}
